(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  document.querySelectorAll('.mdc-language[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mdc-language[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mdc-cart-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '#essential-cart-drawer-portal';
    const observed = new WeakSet();

    function connect() {
      const portal = document.querySelector(selector);
      if (!portal || observed.has(portal)) return false;
      observed.add(portal);
      let pending = false;
      const update = () => {
        pending = false;
        // Keep the empty-cart return link aligned with the public catalogue.
        portal.querySelectorAll('a[href]').forEach((link) => {
          const url = new URL(link.href, document.baseURI);
          if (url.origin === location.origin && /\/collections\/all\/?$/.test(url.pathname)) {
            url.pathname = url.pathname.replace(/\/collections\/all\/?$/, '/collections/lampes-de-chevet-france');
            link.href = url.href;
          }
        });
        portal.querySelectorAll('[data-essential-cart-element="cart-drawer-item-frame"]').forEach(row => {
          const labels = row.querySelectorAll('[data-essential-cart-element="line-item-discounts"]');
          const giftLabel = Array.from(labels).some(label => /\b(cadeau|gift)\b/i.test(label.textContent));
          const link = row.querySelector('a[data-essential-cart-element="line-item-title"][href]');
          const price = row.querySelector('[data-essential-cart-element="line-item-discounted-price"]');
          let gift = false;

          if (giftLabel && link && price) {
            try {
              const url = new URL(link.href, document.baseURI);
              const amount = (price.textContent || '').replace(/[^\d.,-]/g, '');
              gift = url.origin === location.origin
                && /\/products\/cadeau-lampe-usb-projection-coucher-de-soleil\/?$/.test(url.pathname)
                && url.searchParams.get('variant') === '54520301977918'
                && /^0+(?:[.,]0+)?$/.test(amount);
            } catch {}
          }

          row.toggleAttribute('data-mdc-cart-gift', gift); if (gift) { const asset = document.getElementById('mdc-gift-cart-image'); const image = row.querySelector('img[data-essential-cart-element="line-item-image"]'); if (asset && image) { if (image.getAttribute('src') !== asset.dataset.src) image.setAttribute('src', asset.dataset.src); if (image.hasAttribute('srcset')) image.removeAttribute('srcset'); if (asset.dataset.alt && image.alt !== asset.dataset.alt) image.alt = asset.dataset.alt; } } if (gift) { const reference = document.getElementById('mdc-gift-reference-price'); const regular = row.querySelector('[data-essential-cart-element="line-item-regular-price"]'); if (reference && regular) { const referenceText = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: 'EUR' }).format(49.9); const amount = text => Number(text.replace(/[^\d.,-]/g, '').replace(',', '.')); if (amount(regular.textContent) !== 49.9) regular.textContent = referenceText; const accessible = regular.previousElementSibling; if (accessible && accessible.tagName === 'SPAN' && amount(accessible.textContent) !== 49.9) accessible.textContent = accessible.textContent.replace(/\d[\d\s.,]*€/, referenceText); } }
        });
      };
      new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      }).observe(portal, { childList: true, subtree: true, characterData: true });
      update();
      return true;
    }

    if (!connect()) {
      const ready = new MutationObserver(() => {
        if (connect()) ready.disconnect();
      });
      ready.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mdc-chat-invitation"] && !Shopify.designMode) return;
  try {
    const invitation = document.getElementById('MdcChatInvitation');
  if (invitation) {
    const seenKey = 'mdc-chat-invitation-seen-v1';
    const startKey = 'mdc-chat-invitation-start-v1';
    let seen = false;
    let start = Date.now();
    try {
      seen = sessionStorage.getItem(seenKey) === '1';
      const saved = Number(sessionStorage.getItem(startKey));
      if (saved > 0 && saved <= start) start = saved;
      else sessionStorage.setItem(startKey, String(start));
    } catch {}
    let timer;
    let dismissTimer;
    const chat = () => document.querySelector('shopify-chat');
    const activator = () => {
      const root = chat()?.shadowRoot;
      return root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part~="activator"]') ||
        root?.querySelector('button[part~="activator"]');
    };
    const remember = () => {
      seen = true;
      try { sessionStorage.setItem(seenKey, '1'); } catch {}
    };
    const dismiss = () => {
      invitation.hidden = true;
      remember();
      clearInterval(timer);
      clearTimeout(dismissTimer);
    };
    const dismissWhenIdle = () => {
      if (invitation.hidden) return;
      if (invitation.contains(document.activeElement) || invitation.matches(':hover')) {
        dismissTimer = setTimeout(dismissWhenIdle, 1000);
        return;
      }
      dismiss();
    };
    const occupied = () => {
      const input = document.activeElement;
      return document.hidden || chat()?.hasAttribute('open') ||
        Array.from(document.querySelectorAll('dialog[open], theme-drawer[open], header-drawer > details[open], [aria-modal="true"]')).some((element) => {
          const style = getComputedStyle(element);
          const rect = element.getBoundingClientRect();
          return style.visibility !== 'hidden' && style.display !== 'none' &&
            Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0 &&
            rect.left < window.innerWidth && rect.right > 0;
        }) ||
        input?.matches('input, textarea, select, [contenteditable="true"]');
    };
    invitation.querySelector('.mdc-chat-invitation__close').addEventListener('click', dismiss);
    invitation.querySelector('.mdc-chat-invitation__open').addEventListener('click', () => {
      const element = chat();
      dismiss();
      element?.setAttribute('open', '');
    });
    invitation.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') dismiss();
    });
    const tick = () => {
      if (chat()?.hasAttribute('open')) { dismiss(); return; }
      if (!invitation.hidden) {
        if (occupied()) dismiss();
        return;
      }
      if (seen) { clearInterval(timer); return; }
      if (Date.now() - start < 15000 || occupied()) return;
      const button = activator();
      if (!button) return;
      const rect = button.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.top < 260) return;
      invitation.style.bottom = `${Math.max(20, window.innerHeight - rect.top + 12)}px`;
      invitation.hidden = false;
      remember();
      dismissTimer = setTimeout(dismissWhenIdle, 12000);
    };
    if (!seen) timer = setInterval(tick, 500);
    window.addEventListener('pagehide', () => { clearInterval(timer); clearTimeout(dismissTimer); });
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      invitation.hidden = true;
      if (!seen) timer = setInterval(tick, 500);
    });
    window.addEventListener('resize', () => {
      if (!invitation.hidden) dismiss();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mdc-delivery-protection-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const elementName = 'mdc-delivery-protection-cart';
    if (customElements.get(elementName)) return;
    let busy = false;
    let operationNonce = 0;

    async function request(url, body) {
      const response = await fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400 || result.errors) {
        throw new Error(typeof result.description === 'string' ? result.description : '');
      }
      return result;
    }

    class DeliveryProtectionCart extends HTMLElement {
      connectedCallback() {
        this.setBusy(busy);
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', (event) => {
          const control = event.target.closest('.mdc-protection-cart__switch');
          if (!control || !this.contains(control) || control.disabled || busy) return;
          this.toggle(control.getAttribute('aria-checked') !== 'true');
        });
      }

      setBusy(value) {
        const control = this.querySelector('.mdc-protection-cart__switch');
        if (!control) return;
        this.setAttribute('aria-busy', String(value));
        control.disabled = value || (this.dataset.available !== 'true' && control.getAttribute('aria-checked') !== 'true');
      }

      serviceLines(cart) {
        return cart.items.filter((item) => String(item.product_id) === this.dataset.productId);
      }

      hasMerchandise(cart) {
        const eligible = new Set(this.dataset.eligibleProductIds.split(',').filter(Boolean));
        return cart.items.some((item) => eligible.has(String(item.product_id)) && item.requires_shipping && !item.gift_card && item.final_line_price > 0 && !item.properties?.__essential_cart_drawer_reward_tier_id);
      }

      orderUpsellProperties() {
        // Use the published offer's own identifiers so Essential recognizes the
        // same line in its drawer and applies its empty-cart cleanup rules.
        const embed = document.querySelector('essential-cart-app-embed[upsell-app-data]');
        const config = JSON.parse(embed?.getAttribute('upsell-app-data') || '{}');
        for (const cart of config.carts || []) {
          const offer = (cart.orderUpsells || []).find((candidate) =>
            candidate.isEnabled && String(candidate.shopifyVariantId).split('/').pop() === this.dataset.variantId
          );
          if (offer?.id && cart.id) {
            return {
              __essential_cart_drawer_order_upsell_id: offer.id,
              __essential_cart_drawer_upsell_id: cart.id
            };
          }
        }
        throw new Error('');
      }

      async toggle(enable) {
        busy = true;
        const nonce = ++operationNonce;
        document.querySelectorAll(elementName).forEach((element) => element.setBusy(true));
        const error = this.querySelector('.mdc-protection-cart__error');
        error.hidden = true;
        error.textContent = '';
        try {
          let cart = await request(this.dataset.cartUrl + '.js');
          if (enable) {
            if (!this.hasMerchandise(cart)) throw new Error(this.dataset.ineligibleMessage);
            if (!this.serviceLines(cart).length) {
              const properties = this.orderUpsellProperties();
              await request(this.dataset.addUrl, { items: [{ id: Number(this.dataset.variantId), quantity: 1, properties }] });
            }
          } else {
            const maximumRemovals = this.serviceLines(cart).length;
            for (let count = 0; count < maximumRemovals; count++) {
              const line = this.serviceLines(cart)[0];
              if (!line) break;
              cart = await request(this.dataset.changeUrl, { id: line.key, quantity: 0 });
            }
            if (this.serviceLines(cart).length) throw new Error('');
          }
          if (nonce === operationNonce) window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          if (nonce !== operationNonce) return;
          try {
            const cart = await request(this.dataset.cartUrl + '.js');
            this.querySelector('.mdc-protection-cart__switch').setAttribute('aria-checked', String(this.serviceLines(cart).length > 0));
          } catch (_) {}
          error.textContent = [this.dataset.errorMessage, failure.message].filter(Boolean).join(' ');
          error.hidden = false;
          busy = false;
          document.querySelectorAll(elementName).forEach((element) => element.setBusy(false));
        }
      }
    }
    customElements.define(elementName, DeliveryProtectionCart);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mdc-media-preview-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mdc-media-preview-video')) {
    customElements.define('mdc-media-preview-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const button = this.querySelector('[data-preview-play]');
        const stage = this.querySelector('[data-preview-stage]');
        const status = this.querySelector('[data-preview-status]');
        if (!button || !stage || !status) return;
        this.initialized = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          const videoId = this.dataset.videoId;
          if (!['WtQ1V62RG5g', 'CmtAI-W38Mw'].includes(videoId)) return;
          const start = videoId === 'WtQ1V62RG5g' ? 2 : 0;
          const frame = document.createElement('iframe');
          frame.title = this.dataset.title || '';
          frame.width = '1280';
          frame.height = '720';
          frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.setAttribute('allowfullscreen', '');
          frame.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&controls=1&playsinline=1&rel=0&start=${start}`;
          status.hidden = false;
          frame.addEventListener('load', () => {
            status.hidden = true;
            frame.focus();
          }, { once: true });
          stage.replaceChildren(frame);
        }, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mdc-product-premium"] && !Shopify.designMode) return;
  try {
    if (!window.mdcPremiumChooseBound) {
    window.mdcPremiumChooseBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-mdc-premium-choose]');
      if (!link) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      const picker = target.querySelector('variant-picker, [data-variant-picker], .variant-picker');
      const control = picker?.querySelector('select, button, input:not([type="hidden"])') || target.querySelector('input[name="quantity"]') || target.querySelector('button[type="submit"]');
      const destination = picker || target;
      const focusPicker = window.matchMedia('(max-width: 749px)').matches && control?.tagName === 'SELECT';
      if (focusPicker && !destination.hasAttribute('tabindex')) destination.setAttribute('tabindex', '-1');
      destination.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      (focusPicker ? destination : control)?.focus({ preventScroll: true });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
